import Index from './index'

import MockUp from './MockUp'
import TransferInnerMock from './TransferInnerMock'

import UserOld from './UserOld'
import FundRateRecord from './FundRateRecord'
import FundRateBill from './FundRateBill'

export default {
  path: '/home/simulation',
  component: Index,
  meta: { titie: '模拟管理' },
  children: [
    {
      path: '/home/simulation/mockUp',
      meta: { titie: '模拟充提' },
      component: MockUp,
    },
    {
      path: '/home/simulation/transferInnerMock',
      meta: { titie: '模拟盘转账' },
      component: TransferInnerMock,
    },

    {
      path: '/home/simulation/registration',
      meta: { titie: '模拟用户信息' },
      component: UserOld,
    },
    {
      path: '/home/simulation/fundRateRecord',
      meta: { titie: '资金费用记录' },
      component: FundRateRecord,
    },
    {
      path: '/home/simulation/fundRateBill',
      meta: { titie: '资金费用明细' },
      component: FundRateBill,
    },
  ],
}
